/** 时间线列表/轮次共用三列：时刻 | 轨 | 内容 */
export const TIMELINE_LIST_GRID_CLASS =
  'grid w-full min-w-0 auto-rows-min grid-cols-[2.35rem_1.25rem_minmax(0,1fr)] items-start gap-x-2 overflow-visible sm:grid-cols-[2.65rem_1.375rem_minmax(0,1fr)] sm:gap-x-3 md:gap-x-4'

export const TIMELINE_COL_TIME = 'col-start-1'
export const TIMELINE_COL_RAIL = 'col-start-2'
export const TIMELINE_COL_CONTENT = 'col-start-3'
